import { OlsConfigStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import { XHR, getHeaders } from '@wsb/guac-widget-shared/lib/common/ols-core/shop-bundle';
import DigitalWalletStore from './DigitalWalletStore';
import * as PaymentRequestUtils from './PaymentRequestApi';

function shouldUsePaymentRequest() {
  return !OlsConfigStore.getState().stripe_config.payment_intent_on_pdp_and_cart;
}

function getBaseUrl() {
  return OlsConfigStore.getApiBaseUrl();
}

function checkoutUrl(order) {
  return `${getBaseUrl()}/api/checkouts/${order.number}?app=vnext`;
}

function processPayment(order, options) {
  const timeout = OlsConfigStore.getState().requestTimeout.default;
  return XHR.putRequest(checkoutUrl(order), options, timeout, getHeaders(order));
}

export function updateCartShipAddress(order, shippingAddress) {
  // Once PaymentIntent codes are out and stable we can remove codes that use PaymentRequest
  if (shouldUsePaymentRequest()) {
    return PaymentRequestUtils.updateCartShipAddress(order, shippingAddress);
  }

  const timeout = OlsConfigStore.getState().requestTimeout.default;
  return XHR.putRequest(
    checkoutUrl(order),
    {
      order: {
        alternative_attributes: {
          payment_intent: {
            email: null,
            ship_address_attributes: shippingAddress,
            bill_address_attributes: 'same_as_ship_address'
          }
        }
      }
    },
    timeout,
    getHeaders(order)
  );
}

export function updateCartShipMethod(order, shippingOption) {
  // Once PaymentIntent codes are out and stable we can remove codes that use PaymentRequest
  if (shouldUsePaymentRequest()) {
    return PaymentRequestUtils.updateCartShipMethod(order, shippingOption);
  }

  const timeout = OlsConfigStore.getState().requestTimeout.default;
  return XHR.putRequest(
    checkoutUrl(order),
    {
      order: {
        alternative_attributes: {
          payment_intent: {
            shipments_attributes: {
              selected_shipping_rate_id: shippingOption.id
            }
          }
        }
      }
    },
    timeout,
    getHeaders(order)
  );
}

export function processPaymentIntent(order, result, initPage) {
  const { applePayIsSupported } = DigitalWalletStore.getState();
  const options = {
    // We only receive real shopper name at the end. So we need to pass ship_address_attributes.
    // But we don't want to trigger recalculation of shipping & tax. Pass `do_not_set_state` to skip that.
    do_not_set_state: true,
    order: {
      reviewed_total: order.balance_due,
      payment_init_page: initPage,
      payments_attributes: [
        {
          payment_method_list_type: applePayIsSupported ? 'apple' : 'google'
        }
      ],
      alternative_attributes: {
        payment_intent: {
          email: result.payerEmail,
          ship_address_attributes: result.shippingAddress,
          bill_address_attributes: result.paymentMethod.billing_details,
          method_object: {
            cc_type: result.paymentMethod.card.brand,
            method_id: result.paymentMethod.id
          }
        }
      }
    }
  };
  return processPayment(order, options);
}

export function confirmPaymentIntent(order, paymentIntent, stripe_checkout_info) {
  const { payment_id } = stripe_checkout_info;
  const piId = paymentIntent.id;

  const options = {
    order: {
      reviewed_total: order.balance_due,
      alternative_attributes: {
        payment_intent: {
          intent_object: {
            payment_id: payment_id,
            intent_id: piId
          }
        }
      }
    }
  };

  return processPayment(order, options);
}
